// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3q05t","info":"PatientInfo_info__2WUlc"};